import { addPasswordRoute } from "./add-password/route";
import { askPunttChatRoute } from "./ask-puntt/chatRoute";
import { askPunttChatsRoute } from "./ask-puntt/chatsRoute";
import { askPunttProjectsRoute } from "./ask-puntt/projectsRoute";
import { askPunttRoute } from "./ask-puntt/route";
import { authLayoutRoute } from "./auth-layout/route";
import { errorRoute } from "./error/route";
import { forgotPasswordRoute } from "./forgot-password/route";
import { indexRoute } from "./index/route";
import { processRoute } from "./intro/process";
import { resultsRoute } from "./intro/results";
import { startRoute } from "./intro/start";
import { loginRoute } from "./login/route";
import { logoutRoute } from "./logout/route";
import { onboardingRoute } from "./onboarding/route";
import { projectImageUploadRoute } from "./onboarding/routes/create-project";
import { defineRoleRoute } from "./onboarding/routes/define-role";
import { importPortfolioRoute } from "./onboarding/routes/import-portfolio";
import { introExplanationRoute } from "./onboarding/routes/intro-explanation";
import { nameAvatarRoute } from "./onboarding/routes/name-avatar";
import { projectDetailsRoute } from "./onboarding/routes/project-details";
import { reviewPortfolioRoute } from "./onboarding/routes/review-portfolio";
import { whatsNextRoute } from "./onboarding/routes/whats-next";
import { privacyPolicyRoute } from "./privacy-policy/route";
import { resetPasswordRoute } from "./reset-password/route";
import { roiRoute } from "./roi/route";
import { auditLogRoute } from "./roi/routes/audit-log/route";
import { settingsRoute } from "./settings/route";
import { archivedUsersRoute } from "./settings/routes/archivedUsersRoute";
import { integrationSettingsRoute } from "./settings/routes/integrationSettingsRoute";
import { knowledgeDatabaseRoute } from "./settings/routes/knowledge-database/route";
import { knowledgeSettingRoute } from "./settings/routes/knowledgeSettingRoute";
import { usersRoute } from "./settings/routes/usersRoute";
import { ticketsRoute } from "./tickets/route";
import { chromeExtensionRoute } from "./tickets/routes/chrome-extension";
import { figmaPluginRoute } from "./tickets/routes/figma-ticket";
import { ticketRoute } from "./tickets/routes/ticket/route";
import { ticketCompatibilityRoute } from "./tickets/routes/ticket_compat";
import { tutorialTicketsRoute } from "./tutorial/route";
import { tutorialTicketRoute } from "./tutorial/routes/tutorialTicketRoute";
import { unauthLayoutRoute } from "./unauth-layout/route";
import { editProfileRoute } from "./userProfile/base-edit-route";
import { userProfileRoute } from "./userProfile/route";
import { aboutMeEditRoute } from "./userProfile/routes/AboutMe/editRoute";
import { myExpertiseEditRoute } from "./userProfile/routes/MyExpertise/editRoute";
import { myWorkEditRoute } from "./userProfile/routes/MyWork/editRoute";
import { myWorkListRoute } from "./userProfile/routes/MyWork/viewRoute";

export { rootRoute } from "./root/route";
export const appRoutes = [
  startRoute,
  processRoute,
  resultsRoute,
  indexRoute,
  privacyPolicyRoute,
  authLayoutRoute.addChildren([
    onboardingRoute,
    projectImageUploadRoute,
    projectDetailsRoute,
    userProfileRoute,
    addPasswordRoute,
    myWorkListRoute,
    myWorkEditRoute,
    reviewPortfolioRoute,
    importPortfolioRoute,
    defineRoleRoute,
    nameAvatarRoute,
    introExplanationRoute,
    whatsNextRoute,
    editProfileRoute.addChildren([aboutMeEditRoute, myExpertiseEditRoute]),
    ticketsRoute.addChildren([ticketCompatibilityRoute, ticketRoute]),
    settingsRoute,
    knowledgeSettingRoute,
    knowledgeDatabaseRoute,
    integrationSettingsRoute,
    usersRoute,
    archivedUsersRoute,
    figmaPluginRoute,
    tutorialTicketsRoute,
    tutorialTicketRoute,
    errorRoute,

    chromeExtensionRoute,

    // ROI Routes
    roiRoute,
    auditLogRoute,

    // Ask Puntt Routes
    askPunttRoute,
    askPunttProjectsRoute,
    askPunttChatsRoute,
    askPunttChatRoute,
  ]),
  unauthLayoutRoute.addChildren([
    loginRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
  ]),
  logoutRoute,
];
